import React from 'react'
import styled from 'styled-components'
import Image from 'gatsby-image'
import { Icon } from '../shared/Icon'

import {
  desktopVw,
  desktopBreakpoint,
  mobileVw,
  colors,
  fonts,
} from '../../styles'

export const InstagramBlock = ({ image, imageDesktop, title, subtitle }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <Image fluid={image.fluid} alt={image.title} />
      </ImageWrapper>
      <DesktopImageWrapper>
        <Image fluid={imageDesktop.fluid} alt={imageDesktop.title} />
      </DesktopImageWrapper>
      <TextWrapper>
        <Icon name='instagram' color={`${colors.white}`} />
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </TextWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${mobileVw(150)};
  margin-bottom: ${mobileVw(50)};

  @media (min-width: ${desktopBreakpoint}) {
    height: ${desktopVw(384)};
    margin-bottom: 0;
    min-height: auto;
  }
`

const TextWrapper = styled.div`
  padding: ${mobileVw(20)} ${mobileVw(15)};
  color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  @media (min-width: ${desktopBreakpoint}) {
    padding: ${desktopVw(80)} ${desktopVw(400)};
    justify-content: center;
  }
`

const Title = styled.h5`
  font-family: ${fonts.splandor};
  font-size: ${mobileVw(30)};
  text-align: center;
  line-height: ${mobileVw(32)};
  padding: ${mobileVw(5)} 0;

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(54)};
    line-height: ${desktopVw(40)};
    padding: ${desktopVw(16)};
  }
`

const Subtitle = styled.span`
  font-family: ${fonts.tivoli};
  font-size: ${mobileVw(20)};
  letter-spacing: ${mobileVw(2)};
  text-transform: uppercase;

  @media (min-width: ${desktopBreakpoint}) {
    font-size: ${desktopVw(28)};
    letter-spacing: ${desktopVw(2.8)};
  }
`

const ImageWrapper = styled.div`
  z-index: -99;
  position: absolute;
  width: 100vw;
  overflow: hidden;
  max-height: 100%;

  image {
    object-position: center center !important;
  }

  @media (min-width: ${desktopBreakpoint}) {
    display: none;
  }
`

const DesktopImageWrapper = styled.div`
  display: none;

  @media (min-width: ${desktopBreakpoint}) {
    display: block;
    z-index: -99;
    width: 100vw;
    position: absolute;
  }
`
